import { React } from "react";
import { ROUTES_CONST, ORDER_STATUSES, STATUSES_VALUES } from "./constants";
import { act } from "react";


export function convert_routes(arr) {
  let mainArr = [];

  function Recur(arr) {
    arr.forEach((item) => {
      if (item.children.length > 0) {
        mainArr.push({
          path: item.path,
          breadcrumb: item.name,
          metaTitle: item.metaTitle,
          metaDescription: item.metaDescription,
          metaKeywords: item.metaKeywords,
          metaRobots: item.metaRobots
        })
        Recur(item.children);
      } else {
        return mainArr.push({
          path: item.path,
          breadcrumb: item.name,
          metaTitle: item.metaTitle,
          metaDescription: item.metaDescription,
          metaKeywords: item.metaKeywords,
          metaRobots: item.metaRobots
        })
      }
    }
    )
  }

  Recur(arr);
  return mainArr;
}

export function convert_routes_startsWith_products(arr) {
  let mainArr = [];

  function Recur(arr) {
    arr.forEach((item) => {
      if (item.name === 'Новинки' || item.name === 'Лидеры продаж' || item.name === 'Распродажа') return;
      if (item.children.length > 0) {
        mainArr.push({
          path: item.path.replace('/catalog', '/products'),
          breadcrumb: item.name,
        });
        Recur(item.children);
      } else {
        return mainArr.push({
          path: item.path.replace('/catalog', '/products'),
          breadcrumb: item.name,
        });
      }
    }
    );
  }

  Recur(arr);
  return mainArr;
}


export function checkInput(value, min = 8, max = 255, type = 'string') {

  const pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{3,}$/;
  const number_pattern = /^[0-9]+$/;

  switch (type) {
    case 'string': {
      if (value.length < min) return { valid: false, text: `Длина меньше ${min} символов. ` }
      if (value.length > max) return { valid: false, text: `Длина больше ${max} символов. ` }
      return { valid: true, text: '' }
    }
    case 'password': {
      if (!pattern.test(value)) {
        return { valid: false, text: 'Обязательны цифры, заглавные и прописные латинские буквы. ' }
      }
      if (value.length < min) return { valid: false, text: `Длина меньше ${min} символов. ` }
      if (value.length > max) return { valid: false, text: `Длина больше ${max} символов. ` }
      return { valid: true, text: '' }
    }
    case 'email': {
      if (value.length < min) { return { valid: false, text: `Длина меньше ${min} символов. ` } }
      if (value.length > max) return { valid: false, text: `Длина больше ${max} символов. ` }
      if (type === 'email' && !String(value)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
        return { valid: false, text: `Строка не соответствует Email. ` }
      }
      return { valid: true, text: '' }
    }
    case 'tel': {
      const valuestr = String(value);
      if (valuestr.length && (!valuestr.startsWith('8') && !valuestr.startsWith('+7'))) {
        return { valid: false, text: `Номер должен начинаться с +7 или 8` }
      }
      if (valuestr.startsWith('+7') &&
        (valuestr.length !== 12 || !valuestr.match(/^\+\d{11}$/))
      ) {
        return { valid: false, text: `Введите номер в формате +7XXXXXXXXXX или 8XXXXXXXXXX` }
      }
      if (valuestr.startsWith('8') &&
        (valuestr.length !== 11 || !valuestr.match(/^\d{11}$/))
      ) {
        return { valid: false, text: `Введите номер в формате +7XXXXXXXXXX или 8XXXXXXXXXX` }
      }
      return { valid: true, text: '' }
    }
    case 'inn': {
      if (!number_pattern.test(value)) {
        return { valid: false, text: 'Допустимы только цифры. ' }
      }
      if (!(value.length === min || value.length === max)) return { valid: false, text: `Должно быть ${min} или ${max} цифр, сейчас ${value.length}. ` }
      return { valid: true, text: '' }
    }
    case 'ogrn': {
      if (!number_pattern.test(value)) {
        return { valid: false, text: 'Допустимы только цифры. ' }
      }
      if (!(value.length === min || value.length === max)) return { valid: false, text: `Должно быть ${min} или ${max} цифр, сейчас ${value.length}. ` }
      return { valid: true, text: '' }
    }
    case 'number': {
      if (!number_pattern.test(value)) {
        return { valid: false, text: 'Допустимы только цифры. ' }
      }
      if (value.length < min) return { valid: false, text: `Длина меньше ${min} символов. ` }
      if (value.length > max) return { valid: false, text: `Длина больше ${max} символов. ` }
      return { valid: true, text: '' }
    }
    case 'digits': {
      if (!number_pattern.test(value)) {
        return { valid: false, text: 'Допустимы только цифры. ' }
      }
      if (Number(value) < Number(min)) return { valid: false, text: `Введённое число меньше ${min}. ` }
      if (Number(value) > Number(max)) return { valid: false, text: `Введённое число больше ${max}. ` }
      return { valid: true, text: '' }
    }
    default: return { valid: true, text: '' }
  }
}

export function getDataFromRoutes(location, routes, uid = null, token = null) {
  let data = {
    title: 'Неизвестная страница',
    metaTitle: 'Неизвестная страница'
  }
  let index = -1;
  if (uid && token) {
    index = routes.findIndex(route => {
      if (route.path.includes(':uid') && route.path.includes(':token')) {
        let formatRoute = route.path.replace(':uid', uid).replace(':token', token);
        return (formatRoute === location);
      }
      return false;
    });
  } else if (token) {
    index = routes.findIndex(route => {
      if (route.path.includes(':token')) {
        let formatRoute = route.path.replace(':token', token);
        return (formatRoute === location);
      }
      return false;
    });
  } else {
    index = routes.findIndex(route => route.path === location);
  }
  if (index > -1) {
    data.title = routes[index].breadcrumb;
    data.metaTitle = routes[index].metaTitle;
    data.metaDescription = routes[index].metaDescription;
    data.metaKeywords = routes[index].metaKeywords;
    data.metaRobots = routes[index].metaRobots;
  } else {
    data.title = routes[0].breadcrumb;
    data.metaTitle = routes[0].metaTitle;
    data.metaDescription = routes[0].metaDescription;
    data.metaKeywords = routes[0].metaKeywords;
    data.metaRobots = routes[0].metaRobots;
  }
  return data;
}

export function getDataFromArrayWithSlug(slug, array) {
  let data = {
    title: 'Неизвестная страница',
    metaTitle: 'Неизвестная страница',
    metaDescription: '',
    metaKeywords: '',
    metaRobots: 'noindex, nofollow',
  }
  let index = array.findIndex(item => item.slug === slug);

  if (index > -1) {
    data.title = array[index].name;
    data.metaTitle = array[index].metaTitle;
    data.metaDescription = array[index].metaDescription;
    data.metaKeywords = array[index].metaKeywords;
    data.metaRobots = array[index].metaRobots;
  }
  return data;
}

export function getArrayForRoutes(source) {
  let resultList = [];
  source.forEach(item => {
    resultList.push({
      path: item.path,
      breadcrumb: item.name,
      metaTitle: item.metaTitle,
      metaDescription: item.metaDescription,
      metaKeywords: item.metaKeywords,
      metaRobots: item.metaRobots
    })
  });
  return resultList;
}

export function getDataFromCatalogRoutes(location, navigate, routes, slug1 = null) {
  let index = -1;
  if (location === '/catalog') {
    return ROUTES_CONST.find(route => route.path === '/catalog');
  }
  if (location.startsWith('/catalog') && slug1) {
    index = routes.findIndex(route => route.path === location);
    if (index > -1) {
      return routes[index];
    }
  }
  // navigate('/catalog', { replace: true });
  return ROUTES_CONST[0];
}

export function getDataFromProductRoutes(location, navigate, routes, slug1 = null) {
  let index = -1;
  if (location === '/products') {
    return ROUTES_CONST.find(route => route.path === '/products');
  }
  if (location.startsWith('/products/') && slug1) {
    index = routes.findIndex(route => route.path === location);
    if (index > -1) {
      return routes[index];
    }
  }
  // navigate('/catalog', { replace: true });
  return ROUTES_CONST[0];
}


export function setMetaTags(
  metaTitle = '',
  metaDescription = '',
  metaKeywords = '',
  metaRobots = ''
) {
  if (metaTitle) document.title = metaTitle;
  if (metaDescription) {
    document.head.querySelector(`meta[name="description"]`).content = metaDescription;
  }
  if (metaKeywords) {
    document.head.querySelector(`meta[name="keywords"]`).content = metaKeywords;
  }
  if (metaRobots) {
    document.head.querySelector(`meta[name="robots"]`).content = metaRobots;
  }
}


export const setColorInterface = (colorsList) => {
  let root = document.getElementById('root');
  let modal = document.getElementById('modal');
  colorsList.forEach(color => {
    root.style.setProperty(`--${color.name}`, color.color);
  });
  colorsList.forEach(color => {
    modal.style.setProperty(`--${color.name}`, color.color);
  });
}

export const setSharpCorners = (sharp) => {
  const root = document.getElementById('root');
  const modal = document.getElementById('modal');
  const borderRadius = sharp ? '0px' : '4px';
  root.style.setProperty(`--corners`, borderRadius);
  modal.style.setProperty(`--corners`, borderRadius);
}


export const changeDateFormat = (list) =>
  list.map(item => {
    let d = new Date(item.created_date);
    let day = d.getDate();
    const month = d.toLocaleString('ru-RU', { month: 'long' });
    let mod_month;
    let year = d.getFullYear();
    if (d.getMonth() === 2 || d.getMonth() === 7) {
      mod_month = month + 'а'
    } else {
      mod_month = month.replace(/.$/, 'я')
    }
    item.created_date = `${day} ${mod_month} ${year}`;
    return item;
  })

export const changeOneDateFormat = (dateTime) => {
  if (!dateTime || (new Date(dateTime) === "Invalid Date")) {
    return null;
  }
  let d = new Date(dateTime);
  let day = d.getDate();
  const month = d.toLocaleString('ru-RU', { month: 'long' });
  let mod_month;
  let year = d.getFullYear();
  if (d.getMonth() === 2 || d.getMonth() === 7) {
    mod_month = month + 'а'
  } else {
    mod_month = month.replace(/.$/, 'я')
  }
  return `${day} ${mod_month} ${year}`;
}

export const changeOneDateFormatDDMMYYYYHHMM = (dateTime) => {
  if (!dateTime || (new Date(dateTime) === "Invalid Date")) {
    return null;
  }
  let d = new Date(dateTime);
  let day = d.getDate();
  const month = d.toLocaleString('ru-RU', { month: 'long' });
  let mod_month;
  let year = d.getFullYear();
  if (d.getMonth() === 2 || d.getMonth() === 7) {
    mod_month = month + 'а'
  } else {
    mod_month = month.replace(/.$/, 'я')
  }
  let hours = d.getHours();
  let minutes = d.getMinutes();
  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  return `${day} ${mod_month} ${year} ${hours}:${minutes}`;
}

export const changeShortDateFormat = (dateTime) => {
  if (!dateTime || (new Date(dateTime) === "Invalid Date")) {
    return null;
  }
  let d = new Date(dateTime);
  const day = d.getDate();
  let mod_month;
  const month = d.getMonth();
  if (d.getMonth() < 9) {
    mod_month = '0' + (month + 1);
  } else {
    mod_month = month + 1;
  }
  const year = d.getFullYear();
  return `${year}.${mod_month}.${day}`;
}

export const changeShortDateTimeFormat = (dateTime) => {
  if (!dateTime || (new Date(dateTime) === "Invalid Date")) {
    return null;
  }
  let d = new Date(dateTime);
  const day = d.getDate();
  let mod_month;
  const month = d.getMonth();
  if (d.getMonth() < 9) {
    mod_month = '0' + (month + 1);
  } else {
    mod_month = month + 1;
  }
  const year = d.getFullYear();
  let hours = d.getHours();
  let minutes = d.getMinutes();
  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  return `${year}.${mod_month}.${day} ${hours}:${minutes}`;
}

export const paragraphListFromNews = (news) => {
  let paragraphList = [];
  const keysValues = Object.entries(news);
  keysValues.forEach(([key, value]) => {
    let obj = {};
    if (key.startsWith('paragraph')) {
      let index = Number(key.slice(-1)) - 1;
      obj.paragraph = value;
      paragraphList[index] = obj;
    }
    if (key.startsWith('image') && key.slice(-1) === '1' && !key.endsWith('name')) {
      let index = Number(key.slice(-3, -2)) - 1;
      paragraphList[index].image_1 = value;
    }
    if (key.startsWith('image') && key.slice(7, 8) === '1' && key.endsWith('name')) {
      let index = Number(key.slice(5, 6)) - 1;
      paragraphList[index].image_1_name = value;
    }
    if (key.startsWith('image') && key.slice(-1) === '2' && !key.endsWith('name')) {
      let index = Number(key.slice(-3, -2)) - 1;
      paragraphList[index].image_2 = value;
    }
    if (key.startsWith('image') && key.slice(7, 8) === '2' && key.endsWith('name')) {
      let index = Number(key.slice(5, 6)) - 1;
      paragraphList[index].image_2_name = value;
    }
  })
  return paragraphList;
}


export const imagesAndNamesFromNews = (news) => {
  let imagesAndNames = [];
  const keysValues = Object.entries(news);
  keysValues.forEach(([key, value]) => {
    let obj = { image: '', name: '' };
    if (value && key.startsWith('image') && !key.endsWith('name')) {
      obj.image = value;
      obj.name = keysValues.find(item => item[0] === `${key}_name`)[1];
      imagesAndNames.push(obj);
    }
  })
  return imagesAndNames;
}

export const deepFindBySlug = (list, slug) => {
  for (const item of list) {
    if (item.slug === slug) {
      return item;
    }
    if (item.children.length) {
      const found = deepFindBySlug(item.children, slug);
      if (found) return found;
    }
  }
  return null;
};


export const getSaleAndNewCategories = () => ROUTES_CONST.map(r => {
  if (r.path === '/catalog/sale') {
    return ({
      id: -1,
      name: r.breadcrumb,
      path: '/catalog/sale',
      children: [],
      parent: null,
      count_products: 1,
      slug: 'sale'
    })
  }
  if (r.path === '/catalog/new') {
    return ({
      id: -2,
      name: r.breadcrumb,
      path: '/catalog/new',
      children: [],
      parent: null,
      count_products: 1,
      slug: 'new'
    })
  }
  return null;
}).filter(Boolean);


export const getArrayCategoriesWithProducts = (products, allCategories) => {

  let arr = [];

  if (!products.length) return arr;

  products.forEach(product => {
    const currCategory = deepFindBySlug(allCategories, product.category) ||
    {
      name: 'Товары без категорий',
      path: '/catalog',
      slug: 'catalog'
    };
    const indexCategoryInArray = arr.findIndex(item => item.categorySlug === currCategory.slug);
    if (indexCategoryInArray > -1) {
      arr[indexCategoryInArray].products.push(product);
    } else {
      arr.push({
        categoryName: currCategory.name,
        categoryPath: currCategory.path,
        categorySlug: currCategory.slug,
        products: [product]
      })
    }
  });

  return arr;
}


export const checkProductInCart = (productsInCart, product) => {
  if (!Array.isArray(productsInCart) || productsInCart.length === 0) return false;
  return productsInCart.some(item => item.product.id === product.id);
}

export const checkProductInFav = (productsInFav, product) => {
  if (!Array.isArray(productsInFav) || productsInFav.length === 0) return false;
  return productsInFav.some(item => item.id === product.id);
}


export const setPrimaryKeyInProductsList = (cartList) => {
  if (!Array.isArray(cartList) || cartList.length === 0) return [];
  return cartList.map(item => { return { product: item.product.id, count: item.count, active: item.active } })
}

export const setProductInProductsList = (cartList, products) => {
  if (!Array.isArray(cartList) || cartList.length === 0) return [];
  return cartList.map(
    item => {
      return {
        product: products.find(prod => prod.id === item.product),
        count: item.count, active: item.active
      }
    }
  );
}

export const getDateFromOrder = (order) => {
  if (!order) return "";
  switch (order.status) {
    case STATUSES_VALUES.cancelled:
      return order.cancelled_date;
    case STATUSES_VALUES.received:
      return order.received_date;
    case STATUSES_VALUES.await_receipt:
      return order.await_receipt_date;
    case STATUSES_VALUES.delivery:
      return order.delivery_date;
    case STATUSES_VALUES.invoiced:
      return order.invoiced_date;
    case STATUSES_VALUES.created:
      return order.created_date;
    default:
      return null;
  }
}


const getFinalPrice = (product, user) => {
  if (!product || !user) return 1;
  let min_price = product.action_price ? product.action_price : product.price;
  if (user.discount_level === 3) {
    if (product.discount_level_3) {
      return (min_price < product.discount_level_3 ? min_price : product.discount_level_3)
    } else if (product.discount_level_2) {
      return (min_price < product.discount_level_2 ? min_price : product.discount_level_2)
    } else if (product.discount_level_1) {
      return (min_price < product.discount_level_1 ? min_price : product.discount_level_1)
    } else {
      return min_price;
    }
  } else if (user.discount_level === 2) {
    if (product.discount_level_2) {
      return (min_price < product.discount_level_2 ? min_price : product.discount_level_2)
    } else if (product.discount_level_1) {
      return (min_price < product.discount_level_1 ? min_price : product.discount_level_1)
    } else {
      return min_price;
    }
  } else if (user.discount_level === 1) {
    if (product.discount_level_1) {
      return (min_price < product.discount_level_1 ? min_price : product.discount_level_1)
    } else {
      return min_price;
    }
  }
  return min_price;
}


export const cartToOrderProducts = (productsInCart, user, short = false) => {
  if (!Array.isArray(productsInCart) || productsInCart.length === 0) return [];

  const activeProducts = productsInCart.filter(item => item.active);

  return activeProducts.map(item => {
    return ({
      product: short ? item.product.id : item.product,
      quantity_all: item.count,
      price: getFinalPrice(item.product, user)
    })
  })
}

export const repeatToOrderProducts = (productsInRepeat, user, products, short = false) => {
  if (!Array.isArray(productsInRepeat) || productsInRepeat.length === 0) return [];

  // продаём под заказ или нет, проверяем кратность и мин. количество
  const actualProductsList = productsInRepeat.filter(oldProdInRepeat => {
    const actProd = products.find(prod => { return (prod.id === oldProdInRepeat.product.id && !prod.in_archive) })
    if (actProd) {
      return ({
        product: actProd,
        quantity_all: oldProdInRepeat.quantity_all,
        price: getFinalPrice(actProd, user)
      })
    }
  })
  return actualProductsList;
}

export const getStatusName = (status) => {
  if (!status) return "";
  const result = ORDER_STATUSES.find(item => item.value === status);
  if (result && result.name) return result.name;
  return "";
}


export const returnPayer = (order) => {
  if (order.firm) {
    return (`${order.firm.name}`);
  }
  return (returnFIO(order));
}

export const returnFIO = (order) => {
  const I = `${order.customer.first_name[0].toUpperCase()}.`;
  const O = order.customer.surname ? `${order.customer.surname[0].toUpperCase()}.` : '';
  return (`${order.customer.last_name} ${I}${O}`);
}


export const generateCode = (setCode) => {
  const generateRandomChar = (min, max) =>
    String.fromCharCode(Math.floor
      (Math.random() * (max - min + 1) + min));
  let captcha = '';
  for (let i = 0; i < 2; i++) {
    captcha += generateRandomChar(65, 90);
    captcha += generateRandomChar(97, 122);
    captcha += generateRandomChar(48, 57);
  }
  const result = captcha.split('').sort(
    () => Math.random() - 0.5).join('');
  setCode(result);
  return result;
}


export const checkShipment = (shippings, ship_name) => {
  return shippings.find(shipping => shipping.name === ship_name);
}

export const idProdutsInOrders = (products) => {
  return products.map(productObj => ({
    product: productObj.product.id,
    quantity_all: productObj.quantity_all,
    price: productObj.price
  }));
}

export const checkTransportedProducts = (products, productsSet, user) => {
  if (!Array.isArray(productsSet) || productsSet.length === 0) return [];

  // продаём под заказ или нет, проверяем кратность и мин. количество
  let actualProductsList = [];
  productsSet.forEach(oldProdInRepeat => {
    const actProd = products.find(product => {
      return (
        product.id === oldProdInRepeat.product.id && !product.in_archive &&
        (Object.hasOwn(oldProdInRepeat, 'active') ? oldProdInRepeat.active : true) &&
        (product.sell_to_order || (product.available_count >= product.min_count_order))
      )
    });
    if (actProd) {
      const q_all = nearestNumber(
        actProd.sell_to_order,
        actProd.available_count,
        actProd.multiple_count,
        actProd.min_count_order,
        actProd.max_count_order,
        oldProdInRepeat.quantity_all)
      if (q_all > 0) {
        actualProductsList.push({
          product: actProd,
          quantity_all: q_all,
          price: getFinalPrice(actProd, user)
        });
      }
    }
  })
  return actualProductsList;
}

export const diffProductsLists = (oldList, newList) => {
  const diffList = [];
  oldList.forEach(oldItem => {
    const diffObj = {
      product: {},
      available: false,
      price: [],
      quantity_all: [],
      sum: []
    }
    const findItem = newList.find(newItem => oldItem.product.id === newItem.product.id);
    if (!findItem) {
      diffList.push(
        {
          ...diffObj,
          product: oldItem.product,
          available: false
        });
    } else if (findItem.quantity_all !== oldItem.quantity_all || findItem.price !== oldItem.price) {
      const diffQuantity = [];
      const diffPrice = [];
      const diffSumm = [];
      if (findItem.quantity_all !== oldItem.quantity_all) {
        diffQuantity.push(oldItem.quantity_all, findItem.quantity_all)
      }
      if (findItem.price !== oldItem.price) {
        diffPrice.push(oldItem.price, findItem.price)
      }
      diffSumm.push((oldItem.quantity_all * oldItem.price), (findItem.quantity_all * findItem.price));
      diffList.push({
        ...diffObj,
        product: oldItem.product,
        available: true,
        price: diffPrice,
        quantity_all: diffQuantity,
        sum: diffSumm
      });
    }
  });
  console.log('Разница составов =', diffList);
  return diffList;
}

export const convertCartToOrderProductsList = (cartList, user) => {
  if (!Array.isArray(cartList) || cartList.length === 0) return [];
  const orderList = [];
  cartList.forEach(item => {
    if (item.active && !item.product.in_archive) {
      orderList.push({
        product: item.product,
        quantity_all: item.count,
        price: getFinalPrice(item.product, user)
      })
    }
  })
  return orderList;
}

export const nearestNumber = (sell_to_order, available_count, multiple_count, min_count_order, max_count_order, needed_count) => {
  // если не продаём под заказ и в наличии меньше минимального, то возвращаем 0
  if (!sell_to_order && available_count < min_count_order) {
    return 0;
  }
  // если нужное количество меньше минимального, то возвращаем минимальное
  if (needed_count <= min_count_order) {
    return min_count_order
  }
  if (needed_count > max_count_order) {
    if (sell_to_order) {
      // если продаём под заказ, то игнорируем наличие, округляем в большую сторону но не больше чем max_count_order
      return max_count_order
    } else {
      // если не продаём под заказ, то учитываем наличие и не можем продать больше, чем есть
      let result = min_count_order
      for (let i = min_count_order; i <= max_count_order; i += multiple_count) {
        if ((available_count >= (i + multiple_count)) && ((i + multiple_count) <= max_count_order)) {
          result = i + multiple_count;
        }
      }
      return result;
    }
  }
  // если нужное количество больше минимального и меньше максимального, то возвращаем ближайшее к нужному
  if (sell_to_order) {
    // если продаём под заказ, то игнорируем наличие, округляем в большую сторону но не больше чем max_count_order
    return Math.ceil(needed_count / multiple_count) * multiple_count;
  } else {
    // если не продаём под заказ, то учитываем наличие и не можем продать больше, чем есть
    let result = min_count_order
    for (let i = min_count_order; i <= max_count_order; i += multiple_count) {
      if ((available_count >= (i + multiple_count)) && ((i + multiple_count) <= needed_count)) {
        result = i + multiple_count;
      }
    }
    return result;
  }
}


export const convertProductsInCartToShort = (productsInCart) => {
  if (!Array.isArray(productsInCart) || productsInCart.length === 0) return [];
  const activeProducts = []
  productsInCart.forEach(item => {
    if (item.active === false) {
      activeProducts.push({
        product: item.product.id,
        count: item.count,
        active: item.active
      })
    }
  })
  return activeProducts;
}
